import React, {FunctionComponent, useState} from 'react';

import {Alert, ButtonCountdown} from 'components';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@cfa/react-components';
import { AsyncStatus } from 'enums';
import { UpdatePageModel } from '../UpdatePageModel';

interface ICancelUpdateModalProps {
    model: UpdatePageModel,
    show: boolean,
    onClose: () => void,
}

export const CancelUpdateModal: FunctionComponent<ICancelUpdateModalProps> = function(props) {
    const { model, show, onClose } = props;
    if (!model.update) return null;

    const [status, setStatus] = useState(AsyncStatus.Initial);
    const [err, setErr] = useState('');

    function tryHide() {
        // Prevent closing the modal if an API call is in progress.
        if (status !== AsyncStatus.Loading) {
            onClose();
        }
    }

    function onConfirm() {
        if (status === AsyncStatus.Loading) return;

        setStatus(AsyncStatus.Loading);
        model.cancel()
            .then(onClose)
            .catch((err) => {
                setStatus(AsyncStatus.Error);
                setErr(model.apiCallError);
            });
    }

    return (
        <Modal show={show} onClose={tryHide}>
            <ModalHeader>
                Cancel Update
            </ModalHeader>
            <ModalBody>
                <p>
                    Are you sure you want to cancel this update "<b>{model.update.name}</b>"? Deployment of this update will be
                    immediately stopped. Updates cannot be restarted or edited after being canceled.
                </p>
                {status === AsyncStatus.Error && (
                    <Alert type="danger">
                        We're sorry, an error has occurred: {err}
                    </Alert>
                )}
            </ModalBody>
            <ModalFooter>
                <Button
                    variant="outlined"
                    onClick={tryHide}
                    disabled={status === AsyncStatus.Loading}
                >
                    Go Back
                </Button>
                <ButtonCountdown
                    style={{marginLeft: "10px"}}
                    onClick={onConfirm}
                    loading={status === AsyncStatus.Loading}
                    disabled={status === AsyncStatus.Success}
                >
                    {status === AsyncStatus.Loading && 'Canceling update...'}
                    {status !== AsyncStatus.Loading && 'Cancel update'}
                </ButtonCountdown>
            </ModalFooter>
        </Modal>
    );
}